__turbopack_context__.v({
  "affiliated_logo_content": "HeroSubBannerLp-module-scss-module__uC5XNa__affiliated_logo_content",
  "asia_pacific": "HeroSubBannerLp-module-scss-module__uC5XNa__asia_pacific",
  "brochure_share_btn_container": "HeroSubBannerLp-module-scss-module__uC5XNa__brochure_share_btn_container",
  "content_container": "HeroSubBannerLp-module-scss-module__uC5XNa__content_container",
  "content_wrapper": "HeroSubBannerLp-module-scss-module__uC5XNa__content_wrapper",
  "course_name": "HeroSubBannerLp-module-scss-module__uC5XNa__course_name",
  "download_br": "HeroSubBannerLp-module-scss-module__uC5XNa__download_br",
  "duration": "HeroSubBannerLp-module-scss-module__uC5XNa__duration",
  "global_accred": "HeroSubBannerLp-module-scss-module__uC5XNa__global_accred",
  "global_text": "HeroSubBannerLp-module-scss-module__uC5XNa__global_text",
  "img_container": "HeroSubBannerLp-module-scss-module__uC5XNa__img_container",
  "root": "HeroSubBannerLp-module-scss-module__uC5XNa__root",
  "share_icon": "HeroSubBannerLp-module-scss-module__uC5XNa__share_icon",
  "tooltip": "HeroSubBannerLp-module-scss-module__uC5XNa__tooltip",
  "ugc_ent": "HeroSubBannerLp-module-scss-module__uC5XNa__ugc_ent",
});
